import React from "react"
import Layout from "../components/Layout"

const copy = {
  en: {
    title: "Donate Now",
    p1:
      "Your financial donation will help us support churches and faith communities across Canada as they welcome newcomers to their neighbourhoods. Donations towards the Welcome Church project are managed by the Canadian Centre for Christian Charities. Tax-deductible receipts will be issued for gifts over $10.",
    p2:
      "The Donate button will take you directly to Canadian Centre for Christian Charities’ donation portal, where you can make your donation to Welcome Church.",
    button: "Donate",
    p3:
      "Prayer requests and service opportunities are posted through the Welcome Church Internal Portal and are available to registered churches and communities.",
    p4: "Thank you for your donation and your support.",
  },
  cn: {
    title: "奉獻",
    p1:
      "您的金錢奉獻能幫助我們支援全加拿大的教會與信仰群體，讓他們在社區中歡迎新來加的朋友。Welcome Church項目之捐款由 Canadian Centre for Christian Charities（加拿大基督教慈善中心）代為管理。捐款滿 10 加元以上將開立可作報稅用途的收據。",
    p2:
      "按下「捐款」按鈕將帶您前往 Canadian Centre for Christian Charities 的捐款平台，您可以在那裡完成指向 Welcome Church 的奉獻。",
    button: "捐款",
    p3:
      "代禱事項與服事機會會透過 Welcome Church 內部平台發布，提供給已登記的教會與社群。",
    p4: "感謝您的奉獻與支持。",
  },
}

const Donate = ({ lang = "en" }) => {
  const t = key => copy[lang][key]

  return (
    <Layout lang={lang}>
      <section className="about">
        <h2>{t("title")}</h2>
        <p>{t("p1")}</p>
        <p>{t("p2")}</p>
        <a
          className="donate__button"
          href="https://www.cccc.org/welcomechurch"
          target="_blank"
          rel="noreferrer"
        >
          {t("button")}
        </a>
        <p>{t("p3")}</p>
        <p>{t("p4")}</p>
      </section>
    </Layout>
  )
}

export default Donate
